export const getEnv = () => { 
  const env = process.env.REACT_APP_NODE || "prod"
  return env
}

const WEBVIEWER_ENV = getEnv()

export const isDev = WEBVIEWER_ENV === "dev"
export const isProd = WEBVIEWER_ENV === "prod"

const dev = {
  S3_REGION: "ap-northeast-1",
  S3_BUCKET_ARCHFORM_PATIENT_DATA_V1: "archform-patient-data-v1-dev",
  S3_BUCKET_ARCHFORM_WEBVIEWER_DATA_V1: "archform-webviewer-data-v1-dev",
}

const prod = {
  S3_REGION: "us-east-2",
  S3_BUCKET_ARCHFORM_PATIENT_DATA_V1: "archform-patient-data-v1",
  S3_BUCKET_ARCHFORM_WEBVIEWER_DATA_V1: "archform-webviewer-data-v1",
}

const env = {
  S3_REGION: isDev ? dev.S3_REGION : prod.S3_REGION,
  S3_BUCKET_ARCHFORM_PATIENT_DATA_V1: isDev ? dev.S3_BUCKET_ARCHFORM_PATIENT_DATA_V1 : prod.S3_BUCKET_ARCHFORM_PATIENT_DATA_V1,
  S3_BUCKET_ARCHFORM_WEBVIEWER_DATA_V1: isDev ? dev.S3_BUCKET_ARCHFORM_WEBVIEWER_DATA_V1 : prod.S3_BUCKET_ARCHFORM_WEBVIEWER_DATA_V1,
}

export default env